export const IMAGE_UPLOADER_URL = '/system/image-uploader';
